import React from 'react';
import { PriceString } from '../../../../functional/PriceString';
import * as S from './styled';
export const CostItem = ({ name, bold, value, negative }) => {
    return (React.createElement(S.Container, { bold: bold },
        React.createElement(S.Text, null, name),
        React.createElement(S.Cost, null,
            React.createElement(PriceString, { value: value, negative: negative }))));
};
